/**
 * The character window's words (ADR-138's amendment of 2026-10-31, P2.22-T25, P2.26-T24, P1.9-T221): the frame and its
 * tabs, the Character tab's header, attribute rows, points line, Reset, Confirm, the Spend and Respec dialogs, the
 * refusals, the preview panel of derived stats, and the Companions tab. Chrome words name no species: everything
 * specific to a kind of companion is under `companions.kinds` and `companions.words`, one entry per kind. Drafts for
 * the author, none is the author's own.
 */
export const CHARACTER = {
  title: "Character",
  tabs: {
    character: "Character",
    companions: "Companions",
    equipment: "Equipment",
    skills: "Skills",
    titles: "Titles",
  },
  notYet: "Not yet.",
  level: "Lv {level}",
  background: "{background} background",
  noBackground: "No background yet",
  attributes: {
    might: { short: "MIG", name: "Might", effect: "Physical damage dealt" },
    agility: { short: "AGI", name: "Agility", effect: "Pace, blow speed, dodge" },
    vitality: { short: "VIT", name: "Vitality", effect: "Health, resilience" },
    intellect: { short: "INT", name: "Intellect", effect: "Non-physical ability damage" },
    willpower: { short: "WIL", name: "Willpower", effect: "Focus pool, resolve" },
    perception: { short: "PER", name: "Perception", effect: "Critical chance" },
    presence: { short: "PRS", name: "Presence", effect: "How people take to you" },
  },
  add: "Add a point to {name}",
  remove: "Take a point back from {name}",
  pointsLeft: "{left} of {total} points left",
  pointsToSpend: "{count} points to spend",
  pointToSpend: "1 point to spend",
  noPoints: "No points to spend. The next level brings one.",
  unsaved: "Nothing is kept until you confirm.",
  reset: "Reset",
  confirm: "Confirm",
  spendTitle: "Spend {count} points?",
  spendTitleOne: "Spend 1 point?",
  spendBody: "Spent points move again only with a respec.",
  spend: "Spend",
  cancel: "Cancel",
  waiting: "Saving",
  respec: "Respec",
  respecTitle: "Reset every spent point?",
  respecBody: "Every attribute returns to where it started and the points come back to spend again. Free until level 10.",
  respecConfirm: "Reset",
  respecShrine: "From level 10, a respec waits for a Shrine of Attunement. Not yet.",
  refused: {
    none: "Not enough points.",
    cap: "That attribute is as high as it goes for now.",
    combat: "Not while in combat.",
    level: "From level 10, a respec waits for a Shrine of Attunement.",
    spent: "Nothing has been spent.",
    busy: "Still saving. Try again.",
    frozen: "Not while held.",
    points: "Too many points are waiting to be spent for a reset.",
  },
  preview: {
    title: "If you confirm",
    empty: "Add points to see what changes.",
    stats: {
      maxHealth: "Health",
      maxFocus: "Focus",
      physicalDealt: "Physical damage",
      physicalTaken: "Physical damage taken",
      nonPhysicalDealt: "Ability damage",
      critical: "Critical chance",
      dodge: "Dodge chance",
      moveSpeed: "Movement speed",
      blowCooldown: "Blow cooldown",
      focusRegeneration: "Focus regeneration",
      controlDuration: "Crowd control on you",
    },
    percent: "{value}%",
    signedPercent: "{sign}{value}%",
  },
  companions: {
    none: "No companion yet",
    noneLine: "Someone out there might take a liking to you.",
    withMe: "With me",
    atHome: "At home",
    outBadge: "With you",
    homeBadge: "At home",
    frozen: "Not while held.",
    bond: "Bond",
    next: "next: {tier}",
    pips: "Tier {at} of {of}",
    lore: "Animal Lore shows how close the next tier is.",
    today: "Today",
    cloak: "Cloak",
    cloakEmpty: "Nothing worn. A cloak goes here once you have one.",
    list: "Your companions",
    kinds: {
      aethling: "Aethling",
    },
    words: {
      aethling: {
        hungry: "Hungry. A treat would be welcome.",
        fed: "Fed. Content for today.",
      },
    },
  },
} as const;
